import React, { useEffect, useLayoutEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import SelectGroup from '../../../components/casino/SelectGroup';
import CurrencySelect from '../../../components/shared/CurrencySelect';
import CusDatePicker from '../../../components/material-ui/CusDatePicker';
import { Stack } from '@mui/material';
import CusButton from '../../../components/material-ui/CusButton';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store';
import dayjs from 'dayjs';
import { getOnlyData } from '../../../utils';
import {
  setBonusesData,
  setBonusesPayload,
  setBonusesTotal
} from '../../../store/apps/reportsSlice';
import { API_REPORT } from '../../../api/report';
import DatePreset from '../../../components/material-ui/DatePreset';

export default function ReportBonusFilter({ setLoader, setEmpty }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mainGroupId = useAppSelector((state) => state.user.group.main.groupId);
  const mainGroupCurrency = useAppSelector((state) => state.user.group.main.currency);
  const payload = useAppSelector((state) => state.reports.bonuses.payload);

  const prevMount = getOnlyData(dayjs().subtract(30, 'day'));

  const [filterInfo, setFilterInfo] = useState({
    currency: mainGroupCurrency,
    dateFrom: prevMount,
    dateTo: getOnlyData(dayjs()),
    groupId: mainGroupId,
    ...payload
  });

  const dateFrom = filterInfo.dateFrom;
  const dateTo = filterInfo.dateTo;
  const groupId = filterInfo.groupId;

  const gridSize = { sm: 5, xs: 12 };

  const makeTotalObject = async (data) => {
    const total = {
      jackpot: { mini: [0, 0], major: [0, 0], grand: [0, 0] },
      welcome: [0, 0, 0, 0],
      cashback: [0, 0, 0, 0],
      freespin: [0, 0, 0, 0],
      promocode: [0, 0, 0, 0],
      startBot: [0, 0, 0, 0],
      botPhone: [0, 0, 0, 0],
      total: 0
    };

    Object.values(data).forEach((dayData) => {
      // Jackpot
      if (dayData.jackpot) {
        total.jackpot.mini[0] += dayData.jackpot.mini[0];
        total.jackpot.mini[1] += dayData.jackpot.mini[1];
        total.jackpot.major[0] += dayData.jackpot.major[0];
        total.jackpot.major[1] += dayData.jackpot.major[1];
        total.jackpot.grand[0] += dayData.jackpot.grand[0];
        total.jackpot.grand[1] += dayData.jackpot.grand[1];
      }

      // Массивы
      ['welcome', 'cashback', 'freespin', 'promocode', 'startBot', 'botPhone'].forEach((field) => {
        if (dayData[field]) {
          dayData[field].forEach((val, idx) => {
            total[field][idx] += val;
          });
        }
      });
    });

    total.total++;

    dispatch(setBonusesTotal(total));
  };

  useLayoutEffect(() => {
    if (groupId) return;
    setFilterInfo((prev) => ({
      ...prev,
      currency: mainGroupCurrency,
      groupId: mainGroupId
    }));
  }, [groupId, mainGroupId]);

  const onFindClick = () => {
    setLoader(true);
    API_REPORT.list
      .bonuses({ groupId, currency: filterInfo.currency, dateFrom, dateTo })
      .then((e) => {
        dispatch(setBonusesPayload(filterInfo));
        const jackpots = e.data.data;

        makeTotalObject(jackpots);
        dispatch(setBonusesData(jackpots));
        setEmpty(!Object.keys(jackpots).length);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  };

  return (
    <Grid container rowSpacing={1.5} columnSpacing={1} alignItems={'start'}>
      <Grid size={12}>
        <SelectGroup
          title="Group"
          hideTooltip
          selectGroupId={groupId}
          setSelectGroupId={(val) => {
            setFilterInfo((prev) => ({ ...prev, groupId: val, userId: '' }));
          }}
        />
      </Grid>

      <Grid size={gridSize} mt={3}>
        <CusDatePicker
          label="Start Date"
          value={dateFrom}
          onChange={(val) => setFilterInfo((prev) => ({ ...prev, dateFrom: val }))}
          formatChange="YYYY-MM-DD"
        />
      </Grid>
      <Grid size={gridSize} mt={3}>
        <CusDatePicker
          label="End Date"
          value={dateTo}
          onChange={(val) => setFilterInfo((prev) => ({ ...prev, dateTo: val }))}
          formatChange="YYYY-MM-DD"
          errorText={
            dateFrom && dateTo && new Date(dateTo).getTime() < new Date(dateFrom).getTime()
              ? t('End date must be later than start date')
              : ''
          }
        />
      </Grid>
      <Grid size={{ sm: 2, xs: 12 }}>
        <CurrencySelect
          value={filterInfo.currency}
          setValue={(val) => setFilterInfo((prev) => ({ ...prev, currency: val }))}
        />
      </Grid>
      <Grid size={12}>
        <DatePreset
          setStartDate={(val) => setFilterInfo((prev) => ({ ...prev, dateFrom: val }))}
          setEndDate={(val) => setFilterInfo((prev) => ({ ...prev, dateTo: val }))}
          onlyDate
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Stack display={'flex'} justifyContent={'end'} height={'100%'}>
          <CusButton
            text="Find"
            variant="contained"
            sx={{ px: 5 }}
            onClick={() => onFindClick(filterInfo)}
            ml="auto"
          />
        </Stack>
      </Grid>
    </Grid>
  );
}
